import { ref } from 'vue'
import { useRecipeStore } from '@/stores/recipeStore.js'

export default {
  name: 'Home',
  setup() {
    const url = ref('')
    const recipeStore = useRecipeStore()
    const loading = ref(false)

    async function crawlRecipe() {
      loading.value = true
      const recipe = await recipeStore.crawlRecipe(url.value)

      if (recipe?._id) {
        window.location.href = `/recipes/${recipe._id}`
      }
      loading.value = false
    }

    return { url, loading, crawlRecipe }
  },
}
